import { render, staticRenderFns } from "./KpiBenchmark.vue?vue&type=template&id=493df779&scoped=true"
import script from "./KpiBenchmark.vue?vue&type=script&lang=js"
export * from "./KpiBenchmark.vue?vue&type=script&lang=js"
import style0 from "./KpiBenchmark.vue?vue&type=style&index=0&id=493df779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493df779",
  null
  
)

export default component.exports